import { contains } from 'ramda';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { fetchExtension } from './actions';
import { getLoadingList } from './selectors';

const mapStateToProps = state => ({
  extensions: { ...state.extensions.byId, ...state.extensions.byRoute },
  loadingList: getLoadingList(state),
});

const mapDispatchToProps = { fetchExtension };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    fetchExtension: props => (idOrRoute, isBrandPageLookup) => {
      if (props.extensions[idOrRoute]) return;
      if (contains(idOrRoute, props.loadingList)) return;

      props.fetchExtension(idOrRoute, isBrandPageLookup);
    },
  })
);



// WEBPACK FOOTER //
// ./src/app/extensions/withExtensions.js